import {onAuthStateChanged, signInWithPopup, signOut as firebaseSignOut} from 'firebase/auth';
import {doc, getDoc} from 'firebase/firestore';
import {auth, db, googleProvider} from './config';

export const authService = {
  async signInWithGoogle() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      return result.user;
    } catch (error) {
      console.error('Error signing in with Google:', error);
      throw error;
    }
  },

  async signOut() {
    try {
      await firebaseSignOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
      throw error;
    }
  },

  getCurrentUser() {
    return auth.currentUser;
  },

  onAuthStateChanged(callback) {
    return onAuthStateChanged(auth, callback);
  },

  async checkIsAdmin(user) {
    if (!user || !user.email) return false;
    try {
      const docRef = doc(db, 'authorizedEmails', user.email);
      const docSnap = await getDoc(docRef);
      return docSnap.exists() && docSnap.data().isAdmin === true;
    } catch (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
  }
};